<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">직원코드관리</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 1 }" @click="changeMenu(1)">
					직급
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 2 }" @click="changeMenu(2)">
					팀
				</button>
				<!-- DC: 부서와 팀을 '팀' 하나로 합쳤다. 하위 팀(team_cate)은 아무도 쓰지 않아 탭을 내렸다(자료는 그대로 둔다). -->
				<button type="button" class="btn tab" v-bind:class="{ active: menuType == 4 }" @click="changeMenu(4)">
					전문분야
				</button>
			</div>
			<div class="tab-con">
				<div v-if="menuType == 2" class="txt-c--grey mb-1">
					※ 팀장 지정, 팀원 옮기기, 쓰지 않는 팀 정리는 <router-link to="/SystemAdmin/SystemAdmin20">팀 관리</router-link>에서 합니다.
				</div>
				<div class="table-wrap">
					<table class="table" v-if="menuType == 1">
						<colgroup>
							<col width="8%" />
							<col width="7%" />
							<col width="17%" />
							<col width="16%" />
							<col width="17%" />
							<col width="15%" />
							<col width="10%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>직급</th>
							<th>관리 고객 제한수량</th>
							<!-- 매매 고객관리 화면에서 해당 직급이 볼 수 있는 범위 (ind_cfg.cfg_val4) -->
							<th title="매매 고객관리 화면에서 해당 직급이 볼 수 있는 범위입니다. '본인 담당(팀장은 팀)'은 본인 담당 고객이고 직급이 팀장이면 같은 팀 직원의 고객까지 보입니다(본부 고객은 보이지 않습니다). '위 + 미관리 고객'은 여기에 미관리 고객 전체가 더해져 바로 통화·상담할 수 있고, '전체 고객'은 다른 직원이 담당하는 고객까지 모두 보입니다. 관리자(master) 계정은 설정과 무관하게 전체입니다.">
								고객 열람범위
							</th>
							<!-- 업무현황판(직원별 작업내역·실적)에서 그 직급이 누구 것까지 보는지 (ind_cfg.cfg_val3) -->
							<th title="업무현황판에서 해당 직급이 누구의 작업내역·실적까지 볼 수 있는지입니다. 시스템관리자(master) 계정은 이 설정과 무관하게 항상 전체를 봅니다. 팀 배정이 없는 직원은 '본인 팀'을 골라도 본인 것만 보입니다.">
								업무현황 열람범위
							</th>
							<th>사용횟수</th>
							<th>수정</th>
						</tr>
						<tr v-for="(item, idx) in itemList" :key="'codeList_' + item.ind_cfg_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOnOrder(itemList[idx - 1].ind_cfg_uid, item.ind_cfg_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOnOrder(item.ind_cfg_uid, itemList[idx + 1].ind_cfg_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td>{{ item.cfg_val1 }}</td>
							<td>{{ item.cfg_val2 }}</td>
							<td>
								<select
									class="form-control select"
									:value="viewScopeOf(item.cfg_val4)"
									@change="btnOnScope(item.ind_cfg_uid, $event.target.value)"
								>
									<option
										v-for="s in $CLIENT_VIEW_SCOPE_LIST"
										:key="'scope_' + item.ind_cfg_uid + '_' + s.value"
										:value="s.value"
									>
										{{ s.label }}
									</option>
								</select>
							</td>
							<td>
								<select
									class="form-control select"
									:value="workScopeOf(item)"
									@change="btnOnWorkScope(item.ind_cfg_uid, $event.target.value)"
								>
									<option
										v-for="s in $WORKBOARD_SCOPE_LIST"
										:key="'wscope_' + item.ind_cfg_uid + '_' + s.value"
										:value="s.value"
									>
										{{ s.label }}
									</option>
								</select>
							</td>
							<td>{{ item.use_count }}</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnOnEdit(idx)">수정</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">직급</td>
							<td>
								<input type="text" class="form-control" v-model="addInfo.name" />
							</td>
							<td>
								<input type="number" class="form-control" v-model="addInfo.cnt" />
							</td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnOnAdd">추가</button>
							</td>
						</tr>
					</table>
					<table class="table" v-else-if="menuType == 2">
						<colgroup>
							<col width="10%" />
							<col width="10%" />
							<col width="25%" />
							<col width="25%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>팀</th>
							<th>사용횟수</th>
							<th>수정</th>
						</tr>
						<tr v-for="(item, idx) in itemList" :key="'codeList_' + item.ind_cfg_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOnOrder(itemList[idx - 1].ind_cfg_uid, item.ind_cfg_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOnOrder(item.ind_cfg_uid, itemList[idx + 1].ind_cfg_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td>{{ item.cfg_val1 }}</td>
							<td>{{ item.use_count }}</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnOnEdit(idx)">수정</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">팀</td>
							<td colspan="2">
								<input type="text" class="form-control" v-model="addInfo.name" />
							</td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnOnAdd">추가</button>
							</td>
						</tr>
					</table>
					<table class="table" v-else-if="menuType == 3">
						<colgroup>
							<col width="10%" />
							<col width="10%" />
							<col width="25%" />
							<col width="25%" />
							<col width="10%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>부서</th>
							<th>팀</th>
							<th>사용횟수</th>
							<th>수정</th>
						</tr>
						<tr v-for="(item, idx) in itemList" :key="'codeList_' + item.ind_cfg_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOnOrder(itemList[idx - 1].ind_cfg_uid, item.ind_cfg_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOnOrder(item.ind_cfg_uid, itemList[idx + 1].ind_cfg_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td>{{ item.cfg_part3 }}</td>
							<td>{{ item.cfg_val1 }}</td>
							<td>{{ item.use_count }}</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnOnEdit(idx)">수정</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">팀</td>
							<td>
								<select v-model="addInfo.teamId" class="form-control sm select">
									<option value="" selected>선택</option>
									<option :value="t.id" :key="'team_' + t.id" v-for="t in teamList">{{ t.name }}</option>
								</select>
							</td>
							<td>
								<input type="text" class="form-control" v-model="addInfo.name" />
							</td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnOnAdd">추가</button>
							</td>
						</tr>
					</table>
					<table class="table" v-else-if="menuType == 4">
						<colgroup>
							<col width="10%" />
							<col width="10%" />
							<col width="25%" />
							<col width="25%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>전문분야</th>
							<th>사용횟수</th>
							<th>수정</th>
						</tr>
						<tr v-for="(item, idx) in itemList" :key="'codeList_' + item.ind_cfg_uid">
							<td>
								<button
									type="button"
									class="btn sort"
									v-if="idx != 0"
									@click="btnOnOrder(itemList[idx - 1].ind_cfg_uid, item.ind_cfg_uid)"
								>
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != itemList.length"
									@click="btnOnOrder(item.ind_cfg_uid, itemList[idx + 1].ind_cfg_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td>{{ item.cfg_val1 }}</td>
							<td>{{ item.use_count }}</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnOnEdit(idx)">수정</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">전문분야</td>
							<td colspan="2">
								<input type="text" class="form-control" v-model="addInfo.name" />
							</td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnOnAdd">추가</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<div v-if="isSettingPopupShow" class="popup-wrap">
			<div class="dim" @click="isSettingPopupShow = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					{{ $COM_INFO[part] }}
					<button type="button" class="btn btn-close" @click="isSettingPopupShow = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table type-input">
						<colgroup>
							<col width="20%" />
							<col width="80%" />
						</colgroup>
						<template v-if="part == 'team' || part == 'expert_part'">
							<tr>
								<th>{{ $COM_INFO[part] }}</th>
								<td>
									<input type="text" class="form-control" v-model="editInfo.val1" />
								</td>
							</tr>
						</template>
						<template v-else-if="part == 'mem_rank'">
							<tr>
								<th>{{ $COM_INFO[part] }}</th>
								<td>
									<input type="text" class="form-control" v-model="editInfo.val1" />
								</td>
							</tr>
							<tr>
								<th>관리고객제한수량</th>
								<td>
									<input type="text" class="form-control" v-model="editInfo.val2" />
								</td>
							</tr>
						</template>
						<template v-else-if="part == 'team_cate'">
							<tr>
								<th>부서</th>
								<td>
									<!-- <input type="text" class="form-control" v-model="editInfo.val1" /> -->
									<select v-model="editInfo.val1" class="form-control select">
										<option value="" selected>선택</option>
										<option :value="t.id" :key="'team_' + t.id" v-for="t in teamList">{{ t.name }}</option>
									</select>
								</td>
							</tr>
							<tr>
								<th>팀</th>
								<td>
									<input type="text" class="form-control" v-model="editInfo.val2" />
								</td>
							</tr>

							<!-- <td>{{ item.cfg_part3 }}</td>
							<td>{{ item.cfg_val1 }}</td> -->
						</template>
					</table>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-secondary" @click="isSettingPopupShow = false">취소</button>
						<button v-if="part == 'team_cate'" type="button" class="btn btn-sm btn-primary" @click="btnOnSave2">
							저장
						</button>
						<button v-else type="button" class="btn btn-sm btn-primary" @click="btnOnSave">저장</button>
						<button type="button" class="btn btn-sm btn-danger" @click="btnOnDelete">삭제</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin10',
	components: {},
	data() {
		return {
			part: 'mem_rank',
			itemList: [],
			teamList: [],
			addInfo: { name: '', cnt: 0, teamId: '' },
			menuType: 1,

			editInfo: { val1: '', val2: '', id: null, idx: null },
			isSettingPopupShow: false,
		};
	},
	created() {
		this.getItemList();
	},
	computed: {},
	methods: {
		getItemList() {
			this.$apiGET('/admin/api/mem/code?part=' + this.part).then(data => {
				this.itemList = data;
			});
		},
		getTeamList() {
			this.$apiGET('/admin/api/map/team').then(data => {
				this.teamList = data;
			});
		},
		// 저장된 값이 빈값/NULL(설정 전 직급)이거나 아는 값이 아니면 가장 좁은 '본인 담당만' 으로 본다.
		// 백엔드 clientListScope() 도 같은 fallback 을 쓴다 — 한쪽만 바꾸면 화면과 실제 권한이 어긋난다.
		viewScopeOf(val) {
			const known = this.$CLIENT_VIEW_SCOPE_LIST.some(s => s.value === val);
			return known ? val : this.$CLIENT_VIEW_SCOPE.OWN;
		},
		btnOnScope(uid, st) {
			this.$apiPOST('/admin/api/mem/code/flag', { st, uid }).then(() => {
				this.getItemList();
			});
		},
		// 업무현황 열람범위. 저장 전(cfg_val3 가 빈) 직급은 백엔드와 같은 규칙으로 기본값을 보여준다
		// — 화면에 '본인' 이라 떠 있는데 실제로는 팀 전체가 보이는 어긋남을 막는다.
		workScopeOf(item) {
			const v = (item.cfg_val3 || '').trim();
			if (this.$WORKBOARD_SCOPE_LIST.some(s => s.value === v)) return v;

			return this.$WORKBOARD_SCOPE_RANK_DEFAULT[(item.cfg_val1 || '').trim()] || this.$WORKBOARD_SCOPE.SELF;
		},
		btnOnWorkScope(uid, st) {
			this.$apiPOST('/admin/api/mem/code/scope', { st, uid }).then(() => {
				this.getItemList();
			});
		},
		btnOnOrder(uid_2, uid_1) {
			// uid_1 -> uid_2
			// uid_2 -> uid_1
			this.$apiPOST('/admin/api/mem/code/order', { uid_1, uid_2 }).then(() => {
				this.getItemList();
			});
		},
		btnOnAdd() {
			this.$apiPOST('/admin/api/mem/code/add', {
				idx: this.itemList.length + 1,
				name: this.addInfo.name,
				cnt: this.addInfo.cnt,
				part: this.part,
				teamId: this.addInfo.teamId,
			}).then(() => {
				this.clearInfo();
				this.getItemList();
			});
		},
		changeMenu(menu) {
			if (menu == 1) {
				this.part = this.$COM_INFO.MEM_RANK;
			} else if (menu == 2) {
				this.part = this.$COM_INFO.TEAM;
			} else if (menu == 3) {
				this.getTeamList();
				this.part = this.$COM_INFO.TEAM_CATE;
			} else if (menu == 4) {
				this.part = this.$COM_INFO.EXPERT_PART;
			}

			this.getItemList();
			this.menuType = menu;
		},
		clearInfo() {
			this.addInfo.name = '';
			this.addInfo.cnt = 0;
			this.addInfo.teamId = '';
		},
		btnOnEdit(idx) {
			if (this.part == 'team_cate') {
				this.editInfo.val1 = this.itemList[idx].refTeamId;
				this.editInfo.val2 = this.itemList[idx].cfg_val1;
			} else {
				this.editInfo.val1 = this.itemList[idx].cfg_val1;
				this.editInfo.val2 = this.itemList[idx].cfg_val2;
			}

			this.editInfo.id = this.itemList[idx].ind_cfg_uid;
			this.editInfo.idx = idx;
			this.isSettingPopupShow = true;
		},
		btnOnSave() {
			this.$apiPOST('/admin/api/setting/update', {
				val1: this.editInfo.val1,
				val2: this.editInfo.val2,
				id: this.editInfo.id,
				st: 1,
			}).then(re => {
				// J-2/Bug R-2: 실패 시 getItemList + 성공 alert + 팝업 닫기까지 진행되어
				// 사용자가 잘못 알게 됨. backend 명시적 true 일 때만 success 처리.
				if (re !== true) return;
				this.getItemList();
				alert('저장되었습니다.');
				this.isSettingPopupShow = false;
			});
		},
		btnOnSave2() {
			this.$apiPOST('/admin/api/setting/update2', {
				val1: this.editInfo.val1,
				val2: this.editInfo.val2,
				id: this.editInfo.id,
			}).then(re => {
				// J-2/Bug R-2: 동일 패턴 — backend 명시적 true 일 때만 success 처리.
				if (re !== true) return;
				this.getItemList();
				alert('저장되었습니다.');
				this.isSettingPopupShow = false;
			});
		},
		btnOnDelete() {
			if (!confirm('정말로 삭제하시겠습니까?')) {
				return;
			}

			this.$apiPOST('/admin/api/setting/delete', {
				id: this.editInfo.id,
			}).then(re => {
				// J-2/Bug Q-2: 실패 시 splice/updateIdx/팝업 닫기/'삭제되었습니다' alert 까지
				// 모두 진행되어 사용자가 잘못 알게 됨. backend 가 명시적 true 일 때만 success 처리.
				if (re !== true) return;
				this.itemList.splice(this.editInfo.idx, 1);
				this.updateIdx();
				this.isSettingPopupShow = false;
				alert('삭제되었습니다.');
			});
		},
		updateIdx() {
			for (let i = 0; i < this.itemList.length; i++) {
				this.$apiPOST('/admin/api/setting/idx', {
					id: this.itemList[i].ind_cfg_uid,
					idx: i + 1,
				}).then(() => {
					this.getItemList();
				});
			}
		},
		//////    /mem/code/info ,, /mem/code/del
	},
};
</script>

<style></style>
